class ShopTheLookDrawerTrigger extends HTMLButtonElement {
  constructor() {
    super();

    this.productsJSON = JSON.parse(this.querySelector('[data-shop-the-look-products]').textContent).products;
  }

  connectedCallback() {
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick() {
    const event = new CustomEvent('shop-the-look-drawer:update', {
      detail: {
        products: this.productsJSON
      },
      bubbles: true,
    });

    this.dispatchEvent(event);
  }

  initializeElements() {
    this.elements = {
      products: JSON.parse(this.dataset.shopTheLookProducts)
    }
  }
}

customElements.define('shop-the-look-drawer-trigger', ShopTheLookDrawerTrigger, { extends: 'button' });
